import { useState } from 'react';

import { Logo, PartooLogoEnum, STATIC_PROVIDERS_ASSET } from '@partoohub/iconography';

import { useIsDarkTheme } from 'app/Theme';

import { ProviderLogoContainer } from './ProviderLogo.styled';

type Props = {
    providerLabel: string;
};

const ProviderLogo = ({ providerLabel }: Props) => {
    const [isImgFailed, setIsImgFailed] = useState(false);
    const isDarkMode = useIsDarkTheme();

    if (providerLabel === 'partoo') {
        return (
            <Logo
                dataTrackId="partoo_logo"
                name={isDarkMode ? PartooLogoEnum.PartooLogoDark : PartooLogoEnum.PartooLogoLight}
                height="50px"
                width="100%"
            />
        );
    }

    if (isImgFailed) {
        return null;
    }

    return (
        <ProviderLogoContainer>
            <img
                src={`${STATIC_PROVIDERS_ASSET}/${providerLabel}/${providerLabel}_logo.png`}
                onError={() => setIsImgFailed(true)}
                className="logo"
                alt=""
            />
        </ProviderLogoContainer>
    );
};

export default ProviderLogo;
